import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const links = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Workshops',
    href: '#workshops'
  }, {
    name: 'Vendors',
    href: '#vendors'
  }, {
    name: 'Partners',
    href: '#partners'
  }];
  return <nav className="sticky top-0 z-50 bg-foodCream border-b-4 border-foodMaroon" data-id="element-169" data-mp="1g075i9nyhijq">
      <div className="bg-foodMaroon text-foodCream text-center text-sm font-bold uppercase tracking-wide py-2 px-4" data-id="element-170" data-mp="1kyihor1q4554">
        Open Saturdays & Sundays • 11 AM – 3 PM
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171" data-mp="1prutu1p7ujgz">
        <div className="flex justify-between items-center h-20" data-id="element-172" data-mp="1una7asjbadcv">
          <div className="flex-shrink-0 flex items-center" data-id="element-173" data-mp="1yqoxud4vmc4k">
            <a href="#" aria-label="The Food Pavilion, India Basin Waterfront Park" data-id="element-174" data-mp="1yo3utksudq58">
              <img src="https://cdn.magicpatterns.com/uploads/dq4MeNkDnakzMXq35L3LmJ/Untitled_design_(4).png" alt="The Food Pavilion — India Basin Waterfront Park" className="h-[3.3rem] sm:h-[3.96rem] w-auto object-contain mix-blend-multiply" data-id="element-175" data-mp="1y5ow5vcw37oe" />
            </a>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8 ml-8 lg:ml-12" data-id="element-176" data-mp="1k8a22dboybq3">
            {links.map(link => <a key={link.name} href={link.href} className="text-foodOrange hover:text-foodMaroon font-bold transition-colors" data-id="element-177" data-mp="2cuus9agfkhs2">
                {link.name}
              </a>)}
            <a href="https://www.en2action.org/" target="_blank" rel="noopener noreferrer" className="text-foodOrange hover:text-foodMaroon font-bold transition-colors" data-id="element-178" data-mp="2348hpunkmhg8">
              En2Action
            </a>
            <a href="#popups" className="bg-foodOrange text-white px-6 py-2.5 font-bold rounded-none hover:bg-foodTomato transition-colors border-2 border-transparent hover:border-foodMaroon shadow-[4px_4px_0px_0px_#34302A] hover:shadow-[2px_2px_0px_0px_#34302A] hover:translate-y-[2px] hover:translate-x-[2px] active:shadow-none active:translate-y-[4px] active:translate-x-[4px]" data-id="element-179" data-mp="tvwtykb419zk">
              Pop Ups
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center gap-3" data-id="element-180" data-mp="f8bwb5x082z1">
            <a href="https://ibwaterfrontpark.com/" target="_blank" rel="noopener noreferrer" aria-label="India Basin Waterfront Park" data-id="element-181" data-mp="17r8twg59iz7">
              <img src="https://cdn.magicpatterns.com/uploads/nYkbhZjohnn3Xbm3r4WWAs/Untitled_design_(5).png" alt="India Basin Waterfront Park" className="h-12 w-auto object-contain" data-id="element-182" data-mp="1vlsa0nz62i2g" />
            </a>
            <button onClick={() => setIsOpen(!isOpen)} className="text-foodMaroon hover:text-foodOrange focus:outline-none" aria-label="Toggle menu" data-id="element-183" data-mp="2amfv17x7x6n5">
              {isOpen ? <X size={32} data-id="element-184" data-mp="2jioqyclzln4j" /> : <Menu size={32} data-id="element-185" data-mp="2eqdszfat4bem" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="md:hidden bg-foodCream border-t-4 border-foodMaroon absolute w-full" data-id="element-186" data-mp="2tdqgh9k6cr7n">
          <div className="px-4 pt-2 pb-6 space-y-2 shadow-xl" data-id="element-187" data-mp="2of5fv910g5io">
            {links.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-3 text-xl font-display font-bold text-foodOrange hover:bg-foodGold hover:text-foodMaroon transition-colors" data-id="element-188" data-mp="32eez6hkijfqv">
                {link.name}
              </a>)}
            <a href="https://www.en2action.org/" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="block px-3 py-3 text-xl font-display font-bold text-foodOrange hover:bg-foodGold hover:text-foodMaroon transition-colors" data-id="element-189" data-mp="15hiyzli263zr">
              En2Action
            </a>
            <a href="#popups" onClick={() => setIsOpen(false)} className="block mt-4 text-center bg-foodOrange text-white px-6 py-3 font-bold text-xl border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#34302A]" data-id="element-190" data-mp="1jeo0d86tueoo">
              Pop Ups
            </a>
          </div>
        </div>}
    </nav>;
}